import { useState } from 'react';

import { notificationError } from 'app/core/toast';
import i18next from 'i18next';

import { resolveAuthReturnUrl } from '../../../../core/security/returnUrl';
import Service from '../../../../core/security/service';
import {
  type LoginWith2faModel,
  type LoginWithRecoveryCodeModel
} from '../../models/loginWith2fa.model';

export const useLoginWith2fa = () => {
  const [loading, setLoading] = useState(false);
  const [isRecoveryMode, setIsRecoveryMode] = useState(false);

  const login = async (data: LoginWith2faModel) => {
    setLoading(true);
    try {
      const result = await Service.loginWith2fa(data);
      if (result.response) {
        window.location.href = resolveAuthReturnUrl(result.response.returnUrl);
      }
    } catch (error) {
      console.error('Login with 2FA error:', error);
      notificationError(i18next.t('security-login.errors.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  const submitRecoveryCode = async (data: LoginWithRecoveryCodeModel) => {
    setLoading(true);
    try {
      const result = await Service.loginWithRecoveryCode(data);
      if (result.response) {
        window.location.href = resolveAuthReturnUrl(result.response.returnUrl);
      }
    } catch (error) {
      console.error('Login with recovery error:', error);
      notificationError(i18next.t('security-login.errors.recoveryFailed'));
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    isRecoveryMode,
    setIsRecoveryMode,
    login,
    submitRecoveryCode
  };
};
